export enum EVisitorStatusType {
  NotSent = 'not_sent',
  Pending = 'pending',
  Sent = 'sent',
  Deregistered = 'deregistered',
  Canceled = 'canceled',
  Error = 'error',
}

export enum EVisitorActionType {
  CheckIn = 'check-in',
  Deregister = 'deregister',
  Cancel = 'cancel',
}

export interface EVisitorStatus {
  bookingId: string
  status: EVisitorStatusType
  lastAction?: EVisitorActionType
  lastAttemptTime?: string
  referenceId?: string
  errorMessage?: string
}

export interface EVisitorValidation {
  isValid: boolean
  missingFields: string[]
  errors: Record<string, string>
}

export interface EVisitorResponse {
  status: 'accepted' | 'error'
  referenceId?: string
  message?: string
  errorCode?: string
}

export interface EVisitorState {
  statuses: Record<string, EVisitorStatus>
  pendingOperations: Record<string, boolean>
  error: Record<string, string | null>
}

export interface EVisitorCheckinPayload {
  id: string
  guest: {
    firstName: string
    middleName?: string
    lastName: string
    email?: string
    phone?: string
    gender: string
    citizenshipCountryCode: string
    dateOfBirth: number
    birthCountryCode: string
    cityOfBirth?: string
    residenceCountryCode: string
    cityOfResidence: string
    documentType: string
    documentId: string
  }
  stay: {
    arrival: number
    departure: number
    arrivalType: string
    borderCrossing?: string
    passageDate?: number
  }
  host: {
    paymentCategory: string
    facilityCode: string
    accommodationUnitType?: string
    serviceType: string
    residenceAddress?: string
  }
}
